import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DESTINATION_LINKS,
} from '../../../actions/actionTypes';

const destinationLinks = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DESTINATION_LINKS
);

export default destinationLinks;
